/**
 * Single source of truth for how every v2 LMS grade-sync affordance (the sync icons, cross-class cell,
 * and can't-sync popover) looks/behaves — dark, bottom-center, 232px popover. Tweak here to change all.
 */

/** `tooltipProps` for the WithTooltip-based sync icons (error / synced / sync / cross-class). */
export const LMS_SYNC_TOOLTIP_PROPS = {
  theme: 'dark',
  placement: 'bottom',
  showArrow: true
} as const;

/** Base props shared by every v2 LMS sync IconButton — the arrows-rotate glyph + dark bottom tooltip. */
export const LMS_SYNC_ICON_BUTTON_PROPS = {
  icon: 'arrows-rotate',
  iconStyle: 'regular',
  size: 's',
  tooltipProps: LMS_SYNC_TOOLTIP_PROPS
} as const;

/** `position` for the can't-sync Popover — matches the tooltips' bottom-center anchoring. */
export const LMS_SYNC_POPOVER_POSITION = 'bottom' as const;

/** Can't-sync popover content box: 232px max-width + x1/x0-half padding. */
export const LMS_SYNC_POPOVER_CONTENT_CLASS = 'max-w-[232px] px-x1 py-x0-half';
